import React from 'react';
import {User} from '../../react-app-env';

export const UserContext = React.createContext<User>(null as any);

export function useUser() {
  return React.useContext(UserContext);
}
